import { useTranslation } from "react-i18next";
import LogoSM from "./../../assets/images/lnner-stance-logo.svg";
import appstoreImg from "./../../assets/images/welcome-images/app-store.svg";
import googleplayImg from "./../../assets/images/welcome-images/google-play.svg";
import SvgIcon from "../../components/common/SvgIcon";
import { useState, useEffect, useContext } from "react";
// import ChatBot from "../../components/common/ChatBot";
import { useNavigate } from "react-router-dom";
import { socialLinks } from "../../services/socialLinks";
// import { Button } from "alm-react-components";
// import SupportIcon from "../../assets/images/svgicons/support.svg";
import { AppContext } from "../../context/AppProvider";
import { getRedirectPaths, logClick } from "../../lib/utils";
import { APPROUTES } from "../../assets/constants/constants";
import moment from "moment-timezone";

interface SocialLink {
  "social-media": string;
  "media-url": string;
}

interface SocialLinksResponse {
  data: SocialLink[] | object;
}

function Footer() {
  const { t } = useTranslation();
  const { state } = useContext(AppContext);
  const [, setOpenFrame] = useState(false);
  const [, setIsOpenFrame] = useState(false);
  const [socialMediaLinks, setSocialMediaLinks] = useState<SocialLink[]>([]);
  const [error, setError] = useState<string | null>(null); // Error state to store error messages
  const navigate = useNavigate();
useEffect(()=>{
  if(state.globalChatBotkey){
    handleChatBot()
  }
},[state.globalChatBotkey])
  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const response = (await socialLinks()) as SocialLinksResponse; // Type assertion for the response
        const linksData = Array.isArray(response.data) ? response.data : [];
        setSocialMediaLinks(linksData);
      } catch (error: any) {
        console.error("Error fetching social links:", error);
        setError("Error fetching social links. Please try again later.");
      }
    };
    fetchLinks();
  }, []);

  const getLink = (mediaName: string): string | undefined =>
    socialMediaLinks.find(
      (item: SocialLink) => item["social-media"] === mediaName
    )?.["media-url"];

  const hasSocialLinks = [
    "linkedin",
    "instagram",
    "youtube",
    "spotify",
    "tiktok",
  ].some((media) => getLink(media));

  const hasDownloadLinks = getLink("applestore") || getLink("googlestore");

  if (error) {
    return (
      <div className="error-message">
        <p>{error}</p>
      </div>
    );
  }
  const onClicLogo=()=>{
    logClick()
    navigate(APPROUTES.home);
  }

  const handleChatBot=()=>{
      setOpenFrame(true);
      setIsOpenFrame(true);
  }
  return (
    <footer className="bg-white dark:bg-fillMidGrayCard mt-8 w-full bottom-0">


      <div className="bg-white dark:bg-fillMidGrayCard mx-auto w-ful md:py-14 xl:px-32 lg:px-8 md:px-8 px-5 py-6 lg:pt-20 lg:pb-14 ">
        <div className="grid grid-cols-1 gap-8 lg:gap-6 lg:grid-cols-3 md:space-y-5 lg:space-y-0">
          
            <div>
              <h2 className="mb-6 lg:text-xl xl:text-2xl font-barlowMedium dark:text-white"
              dangerouslySetInnerHTML={{
                    __html: t("Footer.company"),
                }}
                /> 
              <ul className="font-normal text-base">
                {getLink("about") && (
                  <li className="mb-3">
                    <a
                      className="hover:underline cursor-pointer"
                      onClick={() =>
                        window.open(
                          getLink("about"),
                          "_blank",
                          "noopener noreferrer"
                        )
                      }
                    
                      dangerouslySetInnerHTML={{
                      __html: t("Footer.about"),
                    }} 
                    />
   
                  </li>
                )}
                {/* <li className="mb-3">
                  <a
                    onClick={() => {handleChatBot()}}
                    className="hover:underline cursor-pointer"
                    dangerouslySetInnerHTML={{
                      __html: t("Footer.help"),
                    }} 
                  />
                </li> */}
              </ul>
            </div>
            {hasSocialLinks && (
              <div>
                <h2 className="mb-6 lg:text-xl xl:text-2xl font-barlowMedium dark:text-white"
                  dangerouslySetInnerHTML={{
                      __html: t("Footer.follow"),
                  }}/>

                <div className="flex mt-4 space-x-5">
                  {getLink("linkedin") && (
                    <a
                      onClick={() =>
                        window.open(
                          getLink("linkedin"),
                          "_blank",
                          "noopener noreferrer"
                        )
                      }
                      className="cursor-pointer"
                      aria-label="linkedin"
                    >
                      <SvgIcon
                        iconName="linkedin-icon"
                        svgProp={{
                          className: "logo h-5 w-5",
                          width: 100,
                          height: 100,
                          fill: "#61dafb",
                          role: "img",
                        }}
                      />
                    </a>
                  )}
                  {getLink("instagram") && (
                    <a
                      onClick={() =>
                        window.open(
                          getLink("instagram"),
                          "_blank",
                          "noopener noreferrer"
                        )
                      }
                      className="cursor-pointer"
                      aria-label="instagram"
                    >
                      <SvgIcon
                        iconName="instagram-icon"
                        svgProp={{
                          className: "logo h-5 w-5 -m-0.5",
                          width: 100,
                          height: 100,
                          fill: "#61dafb",
                          role: "img",
                        }}
                      />
                    </a>
                  )}
                  {getLink("youtube") && (
                    <a
                      onClick={() =>
                        window.open(
                          getLink("youtube"),
                          "_blank",
                          "noopener noreferrer"
                        )
                      }
                      className="cursor-pointer"
                      aria-label="youtube"
                    >
                      <SvgIcon
                        iconName="youtube-icon"
                        svgProp={{
                          className: "logo h-5 w-5 relative mt-[43x]",
                          width: 100,
                          height: 100,
                          fill: "#61dafb",
                          role: "img",
                        }}
                      />
                    </a>
                  )}
                  {getLink("spotify") && (
                    <a
                      onClick={() =>
                        window.open(
                          getLink("spotify"),
                          "_blank",
                          "noopener noreferrer"
                        )
                      }
                      className="cursor-pointer"
                      aria-label="spotify"
                    >
                      <SvgIcon
                        iconName="spotify-icon"
                        svgProp={{
                          className: "logo h-5 w-5",
                          width: 100,
                          height: 100,
                          fill: "#61dafb",
                          role: "img",
                        }}
                      />
                    </a>
                  )}
                  {getLink("tiktok") && (
                    <a
                      onClick={() =>
                        window.open(
                          getLink("spotify"),
                          "_blank",
                          "noopener noreferrer"
                        )
                      }
                      className="cursor-pointer"
                      aria-label="tiktok"
                    >
                      <SvgIcon
                        iconName="tiktok-icon"
                        svgProp={{
                          className: "logo h-5 w-5",
                          width: 100,
                          height: 100,
                          fill: "#61dafb",
                        }}
                      />
                    </a>
                  )}
                </div>
              </div>
            )}
            {hasDownloadLinks && (
              <div>
                <h2 className="mb-6 lg:text-xl xl:text-2xl font-barlowMedium dark:text-white"
                dangerouslySetInnerHTML={{
                  __html: t("Footer.download").replace(/<[^>]*>/g, ""),
              }}/>
                <ul className=" font-normal text-base flex space-x-10">
                  {getLink("applestore") && (
                    <li className="mb-3 md:justify-end inline-block">
                      <a
                        onClick={() =>
                          window.open(
                            getLink("applestore"),
                            "_blank",
                            "noopener noreferrer"
                          )
                        }
                        className="cursor-pointer"
                      >
                        <img
                          width={217}
                          height={72}
                          alt="appstore"
                          src={appstoreImg}
                          className="d-inline-block"
                        />
                      </a>
                    </li>
                  )}
                  {getLink("googlestore") && (
                    <li className="mb-3 md:justify-end inline-block">
                      <a
                        onClick={() =>
                          window.open(
                            getLink("googlestore"),
                            "_blank",
                            "noopener noreferrer"
                          )
                        }
                        className="cursor-pointer"
                      >
                        <img
                          width={217}
                          height={72}
                          alt="googleplay"
                          src={googleplayImg}
                          className="d-inline-block"
                        />
                      </a>
                    </li>
                  )}
                </ul>
              </div>
            )}

        </div>
      </div>

      <div className="bg-white dark:bg-[#000D18] mx-auto w-ful md:px-8 p-4 py-5 xl:px-32 max-sm:pb-12">
        <div className="flex lg:flex-row max-md:gap-6 sm:flex-wrap md:flex-nowrap md:justify-center lg:justify-between align-middle items-center md:space-y-5 lg:space-y-0 max-sm:overflow-x-hidden max-md:flex-col-reverse md:flex-col-reverse">
        
          <div className=" hidden flex-wrap max-sm:flex-wrap max-sm:flex-col md:flex-wrap md:flex-col md:justify-center lg:flex-row lg:justify-between align-middle items-center md:space-y-5 lg:space-y-0">
          
          </div>  
            <div className="text-sm text-gray-500 sm:text-center sm:mx-auto lg:mx-0 dark:text-gray-400">
              <span className="flex items-center"
                  onClick={() => onClicLogo()}
                  >
                <img
                  src={LogoSM}
                  className="h-12 w-12 me-3 cursor-pointer"
                  alt="INNER STANCE"
                />
                <span className="self-center text-base font-normal whitespace-nowrap dark:text-white font-opensansLight"/>
                © {moment().format('YYYY')} {t('Footer.innerStance')}
              </span>
            </div>

            <ul className="font-medium flex max-sm:space-x-0 max-sm:gap-3 max-md:space-x-24 max-sm:flex-wrap max-sm:flex-col md:space-x-10 max-sm:justify-center max-sm:text-center">
              <li className="">
                <a
                  href="/terms-of-services"
                  className="hover:underline whitespace-nowrap font-opensansLight cursor-pointer"
                  onClick={(e: any) => {
                    e.preventDefault();
                    const redirectPaths = getRedirectPaths(location, 'terms-of-services');
                    localStorage.setItem('redirectPaths', JSON.stringify(redirectPaths));
                    navigate('/terms-of-services');
                  }}
                  dangerouslySetInnerHTML={{
                    __html: t("Footer.tandc"),
                }}
                />  
              </li>
              <li className="">
                <a
                  href="/privacy-policy"
                  className="hover:underline whitespace-nowrap font-opensansLight cursor-pointer"
                  onClick={(e: any) => {
                    e.preventDefault();
                    const redirectPaths = getRedirectPaths(location, 'privacy-policy');
                    localStorage.setItem('redirectPaths', JSON.stringify(redirectPaths));
                    navigate('/privacy-policy');
                  }}
                  dangerouslySetInnerHTML={{
                    __html: t("Footer.privacyPolicy"),
                }}
                />  
              </li>
              <li className="">
                <a href="#" className="hover:underline whitespace-nowrap font-opensansLight cursor-pointer"
                onClick={(e: any) => {
                  e.preventDefault();
                  const redirectPaths = getRedirectPaths(location, 'cookie-setting');
                  localStorage.setItem('redirectPaths', JSON.stringify(redirectPaths));
                  navigate('/cookie-setting');[]
                }}
                dangerouslySetInnerHTML={{
                    __html: t("Footer.cookieSetting"),
                }}
                /> 
              </li>
            </ul>

            {/* <div className="flex md:pt-5 lg:pt-5 xl:pt-0 md:justify-start sm:justify-center sm:mt-0 language-dropdown language-dropdown-mobile font-opensansLight">
              <SelectDropdown />
            </div> */}
        
        </div>
      </div>

      <div className="mx-auto w-ful md:px-8 md:py-14 p-4 py-6 lg:py-8 xl:px-32 hidden">
        {/* <div className="grid grid-cols-1 gap-8 lg:gap-6 lg:grid-cols-3 md:space-y-5 lg:space-y-0">
          <div>
            <h2 className="mb-6 lg:text-xl xl:text-2xl font-barlowMedium dark:text-white">
              {t("Footer.company")}
            </h2>
            <ul className="font-normal text-base">
              {getLink("about") && (
                <li className="mb-3">
                  <a
                    className="hover:underline cursor-pointer"
                    onClick={() =>
                      window.open(
                        getLink("about"),
                        "_blank",
                        "noopener noreferrer"
                      )
                    }
                  >
                    {t("Footer.about")}
                  </a>
                </li>
              )}
              <li className="mb-3">
                <a
                  onClick={() => {
                    setOpenFrame(true);
                    setIsOpenFrame(true);
                  }}
                  className="hover:underline cursor-pointer"
                >
                  {t("Footer.help")}
                </a>
              </li>
            </ul>
          </div>
          {hasSocialLinks && (
            <div>
              <h2 className="mb-6 lg:text-xl xl:text-2xl font-barlowMedium dark:text-white">
                {t("Footer.follow")}
              </h2>

              <div className="flex mt-4 space-x-5">
                {getLink("linkedin") && (
                  <a
                    onClick={() =>
                      window.open(
                        getLink("linkedin"),
                        "_blank",
                        "noopener noreferrer"
                      )
                    }
                    className="cursor-pointer"
                    aria-label="linkedin"
                  >
                    <SvgIcon
                      iconName="linkedin-icon"
                      svgProp={{
                        className: "logo h-5 w-5",
                        width: 100,
                        height: 100,
                        fill: "#61dafb",
                        role: "img",
                      }}
                    />
                  </a>
                )}
                {getLink("instagram") && (
                  <a
                    onClick={() =>
                      window.open(
                        getLink("instagram"),
                        "_blank",
                        "noopener noreferrer"
                      )
                    }
                    className="cursor-pointer"
                    aria-label="instagram"
                  >
                    <SvgIcon
                      iconName="instagram-icon"
                      svgProp={{
                        className: "logo h-5 w-5 -m-0.5",
                        width: 100,
                        height: 100,
                        fill: "#61dafb",
                        role: "img",
                      }}
                    />
                  </a>
                )}
                {getLink("youtube") && (
                  <a
                    onClick={() =>
                      window.open(
                        getLink("youtube"),
                        "_blank",
                        "noopener noreferrer"
                      )
                    }
                    className="cursor-pointer"
                    aria-label="youtube"
                  >
                    <SvgIcon
                      iconName="youtube-icon"
                      svgProp={{
                        className: "logo h-5 w-5 relative mt-[43x]",
                        width: 100,
                        height: 100,
                        fill: "#61dafb",
                        role: "img",
                      }}
                    />
                  </a>
                )}
                {getLink("spotify") && (
                  <a
                    onClick={() =>
                      window.open(
                        getLink("spotify"),
                        "_blank",
                        "noopener noreferrer"
                      )
                    }
                    className="cursor-pointer"
                    aria-label="spotify"
                  >
                    <SvgIcon
                      iconName="spotify-icon"
                      svgProp={{
                        className: "logo h-5 w-5",
                        width: 100,
                        height: 100,
                        fill: "#61dafb",
                        role: "img",
                      }}
                    />
                  </a>
                )}
                {getLink("tiktok") && (
                  <a
                    onClick={() =>
                      window.open(
                        getLink("spotify"),
                        "_blank",
                        "noopener noreferrer"
                      )
                    }
                    className="cursor-pointer"
                    aria-label="tiktok"
                  >
                    <SvgIcon
                      iconName="tiktok-icon"
                      svgProp={{
                        className: "logo h-5 w-5",
                        width: 100,
                        height: 100,
                        fill: "#61dafb",
                      }}
                    />
                  </a>
                )}
              </div>
            </div>
          )}
          {hasDownloadLinks && (
            <div>
              <h2 className="mb-6 lg:text-xl xl:text-2xl font-barlowMedium dark:text-white">
                {t("Footer.download")}
              </h2>
              <ul className=" font-normal text-base flex space-x-10">
                {getLink("applestore") && (
                  <li className="mb-3 md:justify-end inline-block">
                    <a
                      onClick={() =>
                        window.open(
                          getLink("applestore"),
                          "_blank",
                          "noopener noreferrer"
                        )
                      }
                      className="cursor-pointer"
                    >
                      <img
                        width={217}
                        height={72}
                        alt="appstore"
                        src={appstoreImg}
                        className="d-inline-block"
                      />
                    </a>
                  </li>
                )}
                {getLink("googlestore") && (
                  <li className="mb-3 md:justify-end inline-block">
                    <a
                      onClick={() =>
                        window.open(
                          getLink("googlestore"),
                          "_blank",
                          "noopener noreferrer"
                        )
                      }
                      className="cursor-pointer"
                    >
                      <img
                        width={217}
                        height={72}
                        alt="googleplay"
                        src={googleplayImg}
                        className="d-inline-block"
                      />
                    </a>
                  </li>
                )}
              </ul>
            </div>
          )}
        </div> */}

        <hr className="border-gray-50 sm:mx-auto dark:border-gray-50 mt-10 mb-8" />

        {/* <div className="flex flex-wrap max-sm:flex-wrap max-sm:flex-col md:flex-wrap md:flex-col md:justify-center lg:flex-row lg:justify-between align-middle items-center md:space-y-5 lg:space-y-0">
          <div className="text-sm text-gray-500 sm:text-center sm:mx-auto lg:mx-0 dark:text-gray-400">
            <p className="flex items-center">
              <img
                src={LogoSM}
                className="h-12 w-12 me-3 cursor-pointer"
                alt="INNER STANCE"
                onClick={() => navigate("/home")}
              />
              <span className="self-center text-base font-normal whitespace-nowrap dark:text-white">
                {t("Footer.innerStance")}{" "}
              </span>
            </p>
          </div>

          <ul className="font-medium flex space-x-24 max-sm:flex-wrap max-sm:flex-col md:space-x-10">
            <li className="">
              <a
                href="/terms-of-services"
                className="hover:underline whitespace-nowrap"
              >
                {t("Footer.tandc")}
              </a>
            </li>
            <li className="">
              <a
                href="/privacy-policy"
                className="hover:underline whitespace-nowrap"
              >
                {t("Footer.privacyPolicy")}
              </a>
            </li>
            <li className="">
              <a href="#" className="hover:underline whitespace-nowrap">
                {t("Footer.cookieSetting")}
              </a>
            </li>
          </ul>

          <div className="flex md:pt-5 lg:pt-5 xl:pt-0 md:justify-start sm:justify-center sm:mt-0 language-dropdown">
            <SelectDropdown />
          </div>
        </div> */}
      </div>
      {/* Old chat bot kept for future changes  */}
      {/* {state?.isAuthenticated && (
        <Button
          variant={"default"}
          onClick={() => {
            setOpenFrame(true);
            setIsOpenFrame(true);
          }}
          className="fixed bottom-[60px] right-[25px] justify-center text-xl font-opensansBold my-2 ml-4 px-3 py-[9px] h-auto z-[1] inline-flex items-center rounded-full group transition-all duration-500 focus:outline-none hover:bg-default"
        >
          <img
            src={SupportIcon}
            alt=""
            aria-label="Support"
            className="logo w-[22px] h-[21px]"
          />
          <span className="whitespace-nowrap inline-block group-hover:max-w-screen-2xl group-focus:max-w-screen-2xl max-w-0 scale-80 group-hover:scale-100 overflow-hidden transition-all duration-500 group-hover:px-2 group-focus:px-2"
          dangerouslySetInnerHTML={{
                    __html: t("HelpCenter.Support"),
                }}
                /> 
        </Button>
      )}
      <ChatBot
          openFrame={openFrame}
          setOpenFrame={setOpenFrame}
          isOpenFrame={isOpenFrame}
      /> */}
    </footer>
  );
}

export default Footer;
